import {
  IconAddressBook,
  IconArrowFork,
  IconBan,
  IconBolt,
  IconBook,
  IconBrandWhatsapp,
  IconCash,
  IconDeviceDesktop,
  IconDeviceMobile,
  IconDeviceMobileMessage,
  IconEye,
  IconEyeCheck,
  IconEyeOff,
  IconFile,
  IconHeartPlus,
  IconHistory,
  IconListSearch,
  IconMail,
  IconMailOpened,
  IconMessage,
  IconMessageChatbot,
  IconMouse,
  IconPhone,
  IconQuestionMark,
  IconReceiptRefund,
  IconSearch,
  IconSend,
  IconShoppingCart,
  IconShoppingCartDown,
  IconShoppingCartPlus,
  IconStar,
  IconStatusChange,
  IconTrash,
  IconTruck,
  IconUserEdit,
  IconUserMinus,
  IconUserPlus,
  IconUserStar,
  IconWand,
  IconWebhook,
} from '@tabler/icons-react';

const iconByEventName = {
  pageView: IconFile,
  pageEngagement: IconEyeCheck,
  productView: IconBook,
  campaignEnter: IconSend,
  campaignSplitEnter: IconArrowFork,
  emailSend: IconSend,
  cartAdd: IconShoppingCartPlus,
  emailDelivery: IconMail,
  recommenderImpression: IconEye,
  recommenderClick: IconMouse,
  cartRemove: IconShoppingCartDown,
  cartCreate: IconShoppingCartPlus,
  emailOpen: IconMailOpened,
  cartCheckoutSuccess: IconCash,
  checkoutInitiate: IconShoppingCart,
  addPaymentInfo: IconCash,
  orderStatusChanged: IconStatusChange,
  refund: IconReceiptRefund,
  emailClick: IconMouse,
  emailReschedule: IconHistory,
  bannerImpression: IconEye,
  bannerClick: IconMouse,
  bannerClose: IconEyeOff,
  subscribe: IconUserPlus,
  unsubscribe: IconUserMinus,
  emailBounce: IconMail,
  emailComplaint: IconMail,
  pushNotificationSubscribe: IconDeviceMobile,
  pushNotificationSend: IconDeviceMobile,
  pushNotificationClick: IconMouse,
  pushNotificationDelivery: IconDeviceMobileMessage,
  textMessageSend: IconMessage,
  textMessageClick: IconMouse,
  viberMessageSend: IconPhone,
  viberMessageClick: IconMouse,
  viberMessageDelivery: IconDeviceMobileMessage,
  viberMessageBounce: IconBan,
  viberMessageOpen: IconMailOpened,
  search: IconSearch,
  autocompleteInteraction: IconListSearch,
  salesAgentProductClick: IconMessageChatbot,
  register: IconUserPlus,
  shipmentStatusUpdate: IconTruck,
  cartUpdate: IconShoppingCart,
  utmSessionStart: IconDeviceDesktop,
  subscribeRequest: IconUserPlus,
  subscriptionsChanged: IconUserEdit,
  emailSkip: IconBan,
  viberMessageExpired: IconTrash,
  viberMessageUknown: IconQuestionMark,
  wishlistCreate: IconStar,
  wishlistAdd: IconStar,
  wishlistRemove: IconTrash,
  whatsappMessageSend: IconBrandWhatsapp,
  whatsappMessageClick: IconMouse,
  whatsappMessageDelivery: IconDeviceMobileMessage,
  whatsappMessageBounce: IconBan,
  whatsappMessageOpen: IconMailOpened,
  generatedProducts: IconWand,
  generatedEmail: IconWand,
  generatedProfileFields: IconWand,
  generatedEmailImages: IconWand,
  webhookSend: IconWebhook,
  webhookClick: IconMouse,
  webhookDelivered: IconWebhook,
  webhookBounce: IconBan,
  webhookOpen: IconMailOpened,
  consentChange: IconAddressBook,
  loyaltyGrant: IconHeartPlus,
  merge: IconUserStar,
  catalogTrigger: IconBolt,
};

const EventIcon = ({ eventName }) => {
  if (eventName.startsWith('shipment')) {
    eventName = 'shipmentStatusUpdate';
  }

  if (eventName.startsWith('Catalog trigger - ')) {
    eventName = 'catalogTrigger';
  }

  const Icon = iconByEventName[eventName] || IconFile;
  return <Icon size={20} />;
};

export default EventIcon;
